import script from "./PropertiesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropertiesSection.vue?vue&type=script&setup=true&lang=ts"

import "./PropertiesSection.vue?vue&type=style&index=0&id=3d4bd0b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4bd0b0"]])

export default __exports__